import Register from "../components/auth/Register";
import Login from "../components/auth/Login";
//import Landing from "../components/layout/landing";
import Dashboard from "../components/dashboard/dashboard";
import Schedulegrid from "../components/dashboard/account/schedules";
import Participants from "../components/dashboard/account/participants";
import Comments from "../components/dashboard/account/comments";
import Settings from "../components/dashboard/account/settings";
import Creatmeeting from "../components/dashboard/createmeeting";
import editmeeting from "../components/dashboard/editmeeting";
import updateschedule from "../components/dashboard/updateschedule";
import passwordreset from "../components/auth/PasswordReset";
import setpassword from "../components/auth/setPassword";
import addparticipants from "../components/dashboard/addparticipants";
import showSchedule from "../components/showschedule";
import adminRegister from "../components/admin/auth/register";
import adminLogin from "../components/admin/auth/login";
import adminDashboard from '../components/admin/dashboard/dashboard';
import changePassword from '../components/admin/auth/changePassword';
import Passwordchange from '../components/auth/changePassword';
import addvt from "../components/admin/dashboard/tabs/addvt"
import mails from "../components/admin/dashboard/tabs/mails"
import schedules from "../components/admin/dashboard/tabs/schedules"
import users from "../components/admin/dashboard/tabs/users"
import ads from "../components/admin/dashboard/tabs/ads"
import editad from "../components/admin/dashboard/tabs/editad"
import privacyPolicy from "../components/layout/privacypolicy"
import terms from "../components/dashboard/terms"

const routes = [
    {
        path: "/",
        component: Creatmeeting,
        name: "home"
    },
    {
        path: "/login",
        component: Login,
        name: "login"
    },
    {
        path: "/register",
        component: Register,
        name: "register"
    },
    {
        path: "/dashboard",
        component: Dashboard,
        name: "dashboard"
    },
    {
        path: "/account/schedules",
        component: Schedulegrid,
        name: "Schedulegrid"
    },
    {
        path: "/account/participants/:id",
        component: Participants,
        name: "Participants"
    },
    {
        path: "/account/comments",
        component: Comments,
        name: "Comments"
    },
    {
        path: "/account/settings",
        component: Settings,
        name: "Settings"
    },
    {
        path: "/createmeeting",
        component: Creatmeeting,
        name: "create"
    },
    {
        path: "/editmeeting/:id",
        component: editmeeting,
        name: "edit"
    },
    
    {
        path: "/updateschedule/:id",
        component: updateschedule,
        name: "updateschedule"
    },
    {
        path: "/resetpassword",
        component: passwordreset,
        name: "reset"
    },
    {
        path: "/setpassword/:id",
        component: setpassword,
        name: "setpassword"
    },
    {
        path: "/schedule/:link",
        component: addparticipants,
        name: "addparticipans"
    },
    {
        path: "/showschedule/:id",
        component: showSchedule,
        name: "showschedule"
    },
    {
        path: "/admin/register",
        component: adminRegister,
        name: "adminregister"
    },
    {
        path: "/admin/login",
        component: adminLogin,
        name: "adminlogin"
    },
    {
        path: "/admin/dashboard",
        component: adminDashboard,
        name: "admindashboard"
    },
    {
        path: "/admin/changepassword",
        component: changePassword,
        name: "changepassword"
    },
    {
        path: "/changepassword",
        component: Passwordchange,
        name: "passwordchange"
    },
    {
        path: "/admin/users",
        component: users,
        name: "users"
    },
    {
        path: "/admin/schedules",
        component: schedules,
        name: "schedules"
    },
    {
        path: "/admin/newadd",
        component: addvt,
        name: "adds"
    },
    {
        path: "/admin/mails",
        component: mails,
        name: "mails"
    },
    {
        path: "/admin/ads",
        component: ads,
        name: "ads"
    },
    {
        path: "/admin/editadd/:id",
        component: editad,
        name: "editad"
    },
    {
        path: "/privacypolicy",
        component: privacyPolicy,
        name: "privacy"
    },
    {
        path: "/terms-and-conditions",
        component: terms,
        name: "terms"
    },
    
];

export default routes;
